import React, { Component } from "react";
import moment from "moment";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Table,
  Button,
  Input,
  Label,
  UncontrolledCollapse,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import * as Server from "../Server";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import { capitalizeFirstLetter } from "../GeneralFunctions";

class EpipathData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      page: 1,
      limit: 10,
      totalUsers: 0,
      pages: 0,
      pageNumbers: [],
      userData: [],
      healthStatus: "default",
      date: new Date(),
      filterCollapse: false,
      notificationModel: false,
    };
  }

  componentDidMount() {
    this.getUserData();
  }

  notifyAll = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "epiPath/notifyAll",
        method: "POST",
        data: {
          date: this.state.date,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          healthStatus: "default",
          date: new Date(),
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getUserData = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.serverRequest({
        url: "epiPath/userData",
        method: "POST",
        data: {
          page: page,
          pageLimit: pageLimit,
          healthStatus:
            this.state.healthStatus !== "default"
              ? this.state.healthStatus
              : "",
          date: this.state.date,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          userData: response.userData,
          totalUsers: response.totalUsers,
          pages: response.pages,
          filterCollapse: false,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getUserData();
    });
  };

  toggleNotificationModel = () => {
    this.setState({ notificationModel: !this.state.notificationModel });
  };

  render() {
    return (
      <div>
        <Page
          title={"Epipath"}
          breadcrumbs={[{ name: "Epipath", active: true }]}
        >
          <PageSpinner showLoader={this.state.showLoader} />
          <Row>
            <Col>
              <Card className="mb-3">
                <CardHeader>
                  <Row>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex">
                        <div sm={4} className="mt-2 pr-2">
                          <Label>Shown</Label>
                        </div>
                        <div sm={4}>
                          <Input
                            type="select"
                            name="pageLimit"
                            onChange={(event) => {
                              this.refreshPagination(1, event.target.value);
                            }}
                          >
                            <option value={10}>10</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </Input>
                        </div>
                        <div sm={4} className="mt-2 pl-2">
                          <Label>entries</Label>
                        </div>
                      </div>
                    </Col>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex justify-content-center">
                        <div className="mt-2 pr-2">
                          <Label>
                            Showing{" "}
                            {!this.state.totalUsers
                              ? 0
                              : this.state.page * this.state.limit -
                                (this.state.limit - 1)}{" "}
                            to{" "}
                            {this.state.page * this.state.limit >
                            this.state.totalUsers
                              ? this.state.totalUsers
                              : this.state.page * this.state.limit}{" "}
                            of {this.state.totalUsers}
                          </Label>
                        </div>
                      </div>
                    </Col>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex justify-content-end">
                        <div sm={4} className="pr-2">
                          <Button
                            className="rounded-circle"
                            disabled={this.state.page <= 1}
                            onClick={(event) =>
                              this.refreshPagination(
                                this.state.page - 1,
                                this.state.limit
                              )
                            }
                          >
                            <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                          </Button>
                        </div>
                        <div sm={4}>
                          <Input
                            type="select"
                            value={this.state.page}
                            name="filter"
                            onChange={(event) => {
                              this.refreshPagination(
                                event.target.value,
                                this.state.limit
                              );
                            }}
                          >
                            {this.state.pageNumbers.length !== 0 ? (
                              this.state.pageNumbers.map(
                                (pageNumber, index) => (
                                  <option value={pageNumber} key={index}>
                                    {pageNumber}
                                  </option>
                                )
                              )
                            ) : (
                              <option value={0}>0</option>
                            )}
                          </Input>
                        </div>
                        <div sm={4} className="pl-2">
                          <Button
                            className="rounded-circle"
                            disabled={this.state.page >= this.state.pages}
                            onClick={(event) =>
                              this.refreshPagination(
                                this.state.page + 1,
                                this.state.limit
                              )
                            }
                          >
                            <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row className="mb-3">
                    <Col xl={12} lg={12} md={12}>
                      <div>
                        <div className="d-flex mb-3 ">
                          <div className="w-50">
                            <Button
                              color="primary"
                              id="toggler1"
                              className="w-50"
                              onClick={() => {
                                this.setState({
                                  filterCollapse: !this.state.filterCollapse,
                                });
                              }}
                            >
                              Filters
                            </Button>
                          </div>
                          <Button
                            onClick={(e) => this.toggleNotificationModel()}
                          >
                            Send Notification (
                            {moment(this.state.date).format("LL")})
                          </Button>
                        </div>
                        <UncontrolledCollapse
                          toggler="#toggler1"
                          isOpen={this.state.filterCollapse}
                        >
                          <Card>
                            <CardBody>
                              <Form
                                className="form"
                                onSubmit={(event) => this.getUserData(event)}
                              >
                                <Row>
                                  <Col
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    style={{ paddingRight: "0px" }}
                                  >
                                    <FormGroup>
                                      <Label for="name">
                                        Search By Health Status:-
                                      </Label>
                                      <div>
                                        <select
                                          className="btn selectCss w-100"
                                          style={{ marginBottom: "10px" }}
                                          value={this.state.healthStatus}
                                          onChange={(event) =>
                                            this.setState({
                                              healthStatus: event.target.value,
                                            })
                                          }
                                        >
                                          <option value="default" disabled>
                                            Select
                                          </option>
                                          <option value="positive">
                                            Positive
                                          </option>
                                          <option value="negative">
                                            Negative
                                          </option>
                                        </select>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col
                                    xl={6}
                                    lg={6}
                                    md={6}
                                    style={{ paddingRight: "0px" }}
                                  >
                                    <FormGroup>
                                      <Label for="name">Search By Date:-</Label>
                                      <Input
                                        type="date"
                                        placeholder="Search by Date"
                                        className="w-100"
                                        value={
                                          moment(
                                            new Date(this.state.date)
                                          ).format("YYYY-MM-DD") || ""
                                        }
                                        onChange={(event) => {
                                          event.persist();
                                          this.setState({
                                            date:
                                              event.target.value !== ""
                                                ? event.target.value
                                                : new Date(),
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={6} lg={12} md={12}>
                                    <FormGroup>
                                      <Button
                                        className="mr-3"
                                        color="primary"
                                        type="submit"
                                      >
                                        Filter
                                      </Button>
                                      <Button
                                        onClick={() =>
                                          this.setState({
                                            date: new Date(),
                                            healthStatus: "default",
                                          })
                                        }
                                      >
                                        Reset Filter
                                      </Button>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Form>
                            </CardBody>
                          </Card>
                        </UncontrolledCollapse>
                      </div>
                    </Col>
                  </Row>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th>Key</th>
                        <th>Mosque Name</th>
                        <th>Mosque Address</th>
                        <th>Entry Time</th>
                        <th>Exit Time</th>
                        <th>Phone Number</th>
                        <th>Health Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.userData.length > 0 ? (
                        this.state.userData.map((data, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor: data.testReport
                                ? data.testReport.testKitImageUploadResult.toLowerCase() ===
                                    "positive" && "rgba(255, 0, 0, 0.61)"
                                : "",
                            }}
                          >
                            <td>{data.address || "-"}</td>
                            <td>
                              {capitalizeFirstLetter(data.mosqueName || "-")}
                            </td>
                            <td>
                              {capitalizeFirstLetter(data.mosqueAddress || "-")}
                            </td>
                            <td>
                              {data.entryTime
                                ? moment
                                    .utc(data.entryTime)
                                    .format("YYYY-MM-DD HH:mm:ss")
                                : "-"}
                            </td>
                            <td>
                              {data.exitTime
                                ? moment
                                    .utc(data.exitTime)
                                    .format("YYYY-MM-DD HH:mm:ss")
                                : "-"}
                            </td>
                            <td>{data.phone || "-"}</td>
                            <td>
                              {data.testReport
                                ? capitalizeFirstLetter(
                                    data.testReport.testKitImageUploadResult
                                  )
                                : "-"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
                {this.state.notificationModel ? (
                  <Modal
                    isOpen={this.state.notificationModel}
                    toggle={(event) => this.toggleNotificationModel()}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) => this.toggleNotificationModel()}
                    ></ModalHeader>
                    <ModalBody>
                      Are you sure you want to send notification ?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) => this.toggleNotificationModel()}
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        disabled={this.state.date.length <= 0}
                        onClick={(event) => {
                          this.notifyAll(event);
                          this.toggleNotificationModel();
                        }}
                      >
                        Send
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}

export default EpipathData;
